module.exports = __webpack_public_path__ + "static/avatar-jamie-4ea1797d6df6853033ca671ba26a4282.png";